<template>
  <v-container grid-list-xl>
    <v-card>
      <v-toolbar flat color="teal lighten-5">
        <v-icon left color="teal darken-2">local_shipping</v-icon>
        <v-toolbar-title class="font-weight-bold teal--text text--darken-2">Göndermen Gerekenler</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="teal darken-2" dark :loading="loading" @click="load" small>
          <v-icon left>refresh</v-icon>Yenile
        </v-btn>
      </v-toolbar>

      <v-layout wrap class="px-3 pt-3">
        <v-flex xs12 sm4 class="px-2">
          <v-card color="teal darken-2" dark flat class="pa-3">
            <div class="caption text-uppercase">Gönderilecek Toplam Has Gram</div>
            <div class="display-1 font-weight-bold">{{ formatGram(summary.totalGram) }} gr</div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 class="px-2">
          <v-card color="teal lighten-1" dark flat class="pa-3">
            <div class="caption text-uppercase">Toplam Adet</div>
            <div class="display-1 font-weight-bold">{{ summary.totalQuantity }}</div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 class="px-2">
          <v-card color="blue-grey lighten-1" dark flat class="pa-3">
            <div class="caption text-uppercase">Farklı Ürün</div>
            <div class="display-1 font-weight-bold">{{ summary.productCount }}</div>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap align-center class="px-3 pt-2">
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" label="Başlangıç Tarihi" prepend-icon="event" readonly clearable v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="startDate" locale="tr-TR" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" label="Bitiş Tarihi" prepend-icon="event" readonly clearable v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="endDate" locale="tr-TR" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-text-field v-model="search" label="Ara (ürün / SKU)" prepend-icon="search" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-btn color="teal darken-2" dark :loading="loading" @click="load">
            <v-icon left>filter_list</v-icon>Listele
          </v-btn>
          <v-btn flat color="grey darken-1" @click="clearDates" :disabled="loading">Temizle</v-btn>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers" :items="filteredItems" :loading="loading" :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
        <template v-slot:items="props">
          <td class="px-2">{{ props.item.productName }}</td>
          <td class="px-2">{{ props.item.sku }}</td>
          <td class="px-2 text-xs-center">{{ props.item.milyem }}</td>
          <td class="px-2 text-xs-right">{{ formatGram(props.item.unitGram) }} gr</td>
          <td class="px-2 text-xs-center">{{ props.item.quantity }}</td>
          <td class="px-2 text-xs-right font-weight-bold">{{ formatGram(props.item.totalGram) }} gr</td>
        </template>
        <template v-slot:no-data>
          <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Gönderilmesi gereken ürün yok.' }}</div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      startDate: null,
      endDate: null,
      search: '',
      tenantId: null,
      mpId: null,
      summary: { totalGram: 0, totalQuantity: 0, productCount: 0, items: [] },
      headers: [
        { text: 'Ürün', value: 'productName', sortable: true },
        { text: 'SKU', value: 'sku', sortable: true },
        { text: 'Milyem', value: 'milyem', sortable: true, align: 'center' },
        { text: 'Birim Gram', value: 'unitGram', sortable: true, align: 'right' },
        { text: 'Adet', value: 'quantity', sortable: true, align: 'center' },
        { text: 'Toplam Has Gram', value: 'totalGram', sortable: true, align: 'right' },
      ],
    };
  },
  computed: {
    filteredItems() {
      const q = (this.search || '').trim().toLocaleLowerCase('tr');
      if (!q) return this.summary.items;
      return this.summary.items.filter((i) =>
        (i.productName || '').toLocaleLowerCase('tr').includes(q) ||
        (i.sku || '').toLocaleLowerCase('tr').includes(q));
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.summary = (await this.$store.dispatch('orders/getPendingShipments', {
          startDate: this.startDate,
          endDate: this.endDate,
        })) || { totalGram: 0, totalQuantity: 0, productCount: 0, items: [] };
      } catch (e) {
        this.summary = { totalGram: 0, totalQuantity: 0, productCount: 0, items: [] };
      } finally {
        this.loading = false;
      }
    },
    clearDates() {
      this.startDate = null;
      this.endDate = null;
      this.load();
    },
    formatGram(value) {
      return (Number(value) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  async mounted() {
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;
    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem('tenantId');
    this.mpId = selectedMp || (currentUser && currentUser.mpId);
    await this.load();
  },
};
</script>
